import {
  AccordionSummary,
  Alert,
  Box,
  styled,
  Typography,
} from '@mui/material';

export const Container = styled(Box)`
  overflow: auto;
`;

export const ContentWrapper = styled(Box)`
  padding: 1.25rem 20px;
`;

export const CommonWrapper = styled(Box)`
  padding: 0.9375rem 0;
`;

export const CommonSubHeading = styled(Typography)(
  () => `
      font-weight: 400;
  `,
);

export const CommonHeading = styled(Typography)(
  () => `
  font-weight: 500;
  font-size: 1.125rem;
`,
);

export const CheckboxList = styled(Box)(
  () => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: left;
  margin: 2px;
  height: 40px;
  `,
);

export const MoveIconStyle = styled(Box)`
  padding-left: 150px;
`;

export const VariationSizeNone = styled(Typography)(
  ({ theme }) => `
  padding: 0.625rem 1.75rem 0.625rem 1.75rem;
  color: ${theme.palette.brand.darkBlue};
  background-color: ${theme.palette.primary.lighter};
  margin-top: 0.5rem;
  font-family: Roboto;
  font-weight: 300;
  font-size: 0.9375rem;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 5px;
  `,
);

export const StyledSortableCheckboxWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  &.dragged {
    z-index: 1200; // to override Mui drawer of 1200
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    background-color: ${theme.palette.common.white} ;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  }
  & svg {
    cursor: grab;
  }
`,
);

export const BackSoonIcon = styled(Box)(
  () => `
  margin-right:12.9375rem;
  padding-top: 10px;
`,
);

export const CustomStyledAlert = styled(Alert)(
  ({ theme }) => `
  margin-bottom:1rem;
  background-color:${theme.palette.brand.whitesmoke};
  color: ${theme.palette.brand.charcoal};
  text-align: center;

  & a {
    color: ${theme.palette.brand.charcoal};
    text-decoration-color: ${theme.palette.brand.charcoal};
  }
  `,
);

export const TypographyWithBorder = styled(Typography)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.secondary.lighter};
  padding: 20px 0 10px 0;
`,
);

export const ButtonContainer = styled(Box)(
  ({ $hasbundleimages }) => `
  padding: 0 20px;
  padding-top: ${$hasbundleimages ? '0px' : '15px'}
`,
);

export const AccordionSummaryWithBorder = styled(AccordionSummary)(
  ({ theme }) => `
  border-bottom: 1px solid ${theme.palette.brand.black};
`,
);
